import { render, staticRenderFns } from "./success.vue?vue&type=template&id=b6f2ddfc&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"
import style0 from "./success.vue?vue&type=style&index=0&id=b6f2ddfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f2ddfc",
  null
  
)

export default component.exports